import { Outlet } from "react-router";

export default function HomeLayout() {
  return (
    <div>
      <div className="bg-auto-blue-dark  min-h-screen">
        <Outlet />
      </div>
    </div>
  );
}
